module.exports = __webpack_public_path__ + "static/media/Ellipse.95195c22.webp";